import { BRAND } from "@/lib/constants";

export const SiteFooter = () => (
  <footer className="no-print border-t border-slate-800 bg-slate-950 text-slate-400">
    <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-6 md:grid-cols-3">
      <div>
        <p className="text-lg font-extrabold text-white">{BRAND.name}</p>
        <p className="mt-2 text-sm">Personal auto, commercial auto liability, general liability and SR22 insurance in all 50 states and DC. Pay online and download or print your policy.</p>
      </div>
      <div className="text-sm">
        <p className="eyebrow !text-slate-300">Help, 24/7 online</p>
        <p className="mt-2 text-slate-300" data-testid="footer-help">Everything happens in your online account: quotes, payments, policy documents, claims and our AI assistant for instant answers.</p>
      </div>
      <div className="text-xs leading-relaxed">
        Prices are based on the information you provide. Coverage is subject to the policy terms; misstated information may change your premium or coverage.
      </div>
    </div>
    <div className="border-t border-slate-800 py-4 text-center font-mono text-xs">© {new Date().getFullYear()} {BRAND.name}</div>
  </footer>
);
